import React from 'react';

import { requestLogin } from '../../messagebus';

export const LoginButton = ({ label }) => {
  return <div className="sb-header__item">
    <button
      className="action-login__button"
      onClick={requestLogin}
      key={'pih.login'}
      data-test-id='@sitebase/login-button_loginButtonId'
    >
    {label}
    </button>
  </div>
}
